import http from "../http-common";

class JobDataService {
  getAll() {
    return http.get("/jobs");
  }

  getJobByDescr(condition, sortfield,sorttype) {
    return http.get(`/jobs/search/?jobtitle=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/jobs/${id}`);
  }

  create(data) {
    return http.post("/jobs/newjob", data);
  }

  update(id, data) {
    return http.put(`/jobs/${id}`, data);
  }

  delete(id) {
    return http.delete(`/jobs/${id}`);
  }

  deleteAll() {
    return http.delete(`/jobs`);
  }

  findById(id) {
    return http.get(`/jobs?id=${id}`);
  }
}

export default new JobDataService();